import React, { useState, useEffect } from 'react';
import { Box, Typography, Link, Container } from '@mui/material';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { UNAUTHENTICATED } from '../../constants/user';
import { useThemeContext } from '../../contexts/BaseThemeContextProvider';

const app_co = process.env.REACT_APP_COMPANY;
const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL;
const app_domain = process.env.REACT_APP_HOST_DOMAIN;

const getHipaaNoticeUrl = () => {
  return `https://${app_domain}/hipaa-notice-of-privacy-practices`;
};

const Footer = () => {
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  const [showSupport, setShowSupport] = useState(authStatus === UNAUTHENTICATED && app_co !== 'frost');
  const { theme } = useThemeContext();
  const hipaaNoticeUrl = getHipaaNoticeUrl();
  const poweredByLogoSrc = app_co === 'frost' ? theme.images?.poweredByRH?.src : undefined;

  useEffect(() => {
    // Update showSupport whenever authStatus changes
    setShowSupport(authStatus === UNAUTHENTICATED && app_co !== 'frost');
  }, [authStatus]);

  return (
    <Container maxWidth="md" sx={{ display: 'flex' }}>
      <Box
        component="footer"
        sx={{
          textAlign: 'center',
          position: 'relative',
          bottom: 0,
          width: '100%',
          maxWidth: 'md',
          minHeight: { xs: '5vh', md: '10vh' },
          padding: { xs: '24px 16px', md: 0 },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: { xs: 'center', md: 'space-between' },
            alignItems: 'center',
            height: '100%',
            gap: { xs: '16px', md: 0 },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'row',
              gap: { xs: '16px', md: 0 },
            }}
          >
            <Typography
              sx={{
                color: theme.typography.links.default.color,
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: '400',
                lineHeight: '20px',
                letterSpacing: '0.25px',
              }}
            >
              <Link href={`mailto:${SUPPORT_EMAIL}`} color="inherit" underline="none">
                {SUPPORT_EMAIL}
              </Link>
            </Typography>
            {showSupport && (
              <Typography
                sx={{
                  color: theme.custom.pages.footer.support.color,
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: '700',
                  lineHeight: '24px',
                  letterSpacing: '0.5px',
                  marginLeft: '16px',
                  display: 'flex',
                }}
              >
                <Link
                  href="/support.html"
                  color="inherit"
                  underline="none"
                  sx={{ display: 'flex', alignItems: 'center' }}
                >
                  <img
                    src={theme.custom.pages.footer.support.images.src}
                    alt="support help"
                    style={{ marginRight: '4px' }}
                  />
                  Support
                </Link>
              </Typography>
            )}
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {app_co === 'frost' && (
              <Typography
                sx={{
                  color: theme.custom.pages.footer.privacyPolicy.color,
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: '700',
                  lineHeight: '20px',
                  letterSpacing: '0.25px',
                }}
              >
                <Link href={hipaaNoticeUrl} color="inherit" underline="none" target="_blank" rel="noopener noreferrer">
                  HIPAA Privacy Notice |
                </Link>
              </Typography>
            )}
            <Typography
              sx={{
                color: theme.custom.pages.footer.termsOfService.color,
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: '700',
                lineHeight: '20px',
                letterSpacing: '0.25px',
              }}
            >
              <Link href="/tos.html" color="inherit" underline="none">
                {<> &nbsp;Terms of Service&nbsp;</>}
              </Link>
            </Typography>
            <Typography
              sx={{
                color: theme.custom.pages.footer.privacyPolicy.color,
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: '700',
                lineHeight: '20px',
                letterSpacing: '0.25px',
              }}
            >
              <Link href="/privacy-policy.html" color="inherit" underline="none">
                | Privacy Policy
              </Link>
            </Typography>
            <Box sx={{ marginLeft: '15px', textAlign: 'center' }}>
              {app_co === 'frost' && (
                <Link
                  href="https://www.relentlesshealth.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ display: 'inline-block' }}
                >
                  <Box
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '6px 10px',
                    }}
                  >
                    <Box
                      component="img"
                      src={poweredByLogoSrc}
                      alt="Powered by Relentless Health"
                      sx={{ display: 'block', height: '28px' }}
                    />
                  </Box>
                </Link>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default Footer;
